class Wishlist {
  constructor() {
    this.wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
    // Filter out invalid items on load
    this.wishlistData = this.wishlistData.filter(item => this.isValidWishlistItem(item));

    // Cache frequently used selectors
    this.headerWishlistIcon = document.querySelector('.header__icon--wishlist');
    this.wishlistBlock = document.querySelector('.js-wishlistBlock');

    // Bind delegated events BEFORE any other logic so dynamically-added buttons work
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.wishlist-button');
      if (!button) return;
      event.preventDefault();
      this.toggleWishlist(button);
    });

    this.init();
  }

  init() {
    // Initial button state update for all existing buttons
    this.updateAllButtonStates();
    this.updateHeaderIcon();
    this.displayWishlist();
  }

  isValidWishlistItem(item) {
    return item && 
           typeof item === 'object' &&
           item.id && 
           item.handle && 
           item.title && 
           item.image && 
           item.price && 
           item.url;
  }

  getProductData(button) {
    const data = {
      id: button.getAttribute('data-product-id'),
      handle: button.getAttribute('data-product-handle'),
      title: button.getAttribute('data-product-title'),
      image: button.getAttribute('data-product-image'),
      price: button.getAttribute('data-product-price'),
      url: button.getAttribute('data-product-url')
    };

    // Only return the data if all required fields are present
    return this.isValidWishlistItem(data) ? data : null;
  }

  toggleWishlist(button) {
    const productData = this.getProductData(button);
    if (!productData) return; // Don't proceed if data is invalid

    const isInWishlist = this.isProductInWishlist(productData.id);

    if (!isInWishlist) {
      this.wishlistData.push(productData);
    } else {
      this.wishlistData = this.wishlistData.filter(item => item.id !== productData.id);
    }

    localStorage.setItem('wishlist', JSON.stringify(this.wishlistData));
    this.updateAllButtonStates();
    this.updateHeaderIcon();
    this.displayWishlist();
    this.triggerHeaderBounce();
  }

  isProductInWishlist(productId) {
    return this.wishlistData.some(item => item.id === productId);
  }

  updateButtonState(button) {
    if (!button) return;

    const productData = this.getProductData(button);
    if (!productData) return;
    
    const isInWishlist = this.isProductInWishlist(productData.id);

    button.setAttribute('data-in-wishlist', isInWishlist);
    button.setAttribute('aria-label', isInWishlist ? 'Remove from Wishlist' : 'Add to Wishlist');
  }

  updateHeaderIcon() {
    if (!this.headerWishlistIcon) return;
    
    if (this.wishlistData.length > 0) {
      this.headerWishlistIcon.classList.add('has-items');
    } else {
      this.headerWishlistIcon.classList.remove('has-items');
    }
  }

  displayWishlist() {
    if (!this.wishlistBlock) return;

    if (this.wishlistData.length === 0) {
      this.wishlistBlock.innerHTML = '<div class="text-center wishlist-empty-container"><p class="wishlist-empty">Your wishlist is empty</p></div>';
      return;
    }

    const wishlistHtml = this.wishlistData.map(item => `
      <div class="wishlist-item">
        <div class="wishlist-item__image">
          <a href="${item.url}">
            <img src="${item.image}" alt="${item.title}" loading="lazy">
          </a>
        </div>
        <div class="wishlist-item__info">
          <h3 class="wishlist-item__title">
            <a href="${item.url}">${item.title}</a>
          </h3>
          <div class="wishlist-item__price">${item.price}</div>
          <button 
            type="button" 
            class="wishlist-item__remove button button--secondary"
            data-product-id="${item.id}"
            onclick="window.wishlist.removeFromWishlist('${item.id}')"
          >
            Remove
          </button>
        </div>
      </div>
    `).join('');

    this.wishlistBlock.innerHTML = wishlistHtml;
  }

  removeFromWishlist(productId) {
    this.wishlistData = this.wishlistData.filter(item => item.id !== productId);
    localStorage.setItem('wishlist', JSON.stringify(this.wishlistData));

    this.updateAllButtonStates();
    this.updateHeaderIcon();
    this.displayWishlist();
    this.triggerHeaderBounce();
  }

  // Utility to update the state for ALL wishlist buttons currently in the DOM
  updateAllButtonStates() {
    const buttons = document.querySelectorAll('.wishlist-button');
    buttons.forEach((btn) => this.updateButtonState(btn));
  }

  // Triggers a bounce animation on the header wishlist icon
  triggerHeaderBounce() {
    if (!this.headerWishlistIcon) return;
    this.headerWishlistIcon.classList.remove('wishlist-icon-bounce');
    // Force reflow to restart animation each time
    void this.headerWishlistIcon.offsetWidth;
    this.headerWishlistIcon.classList.add('wishlist-icon-bounce');
  }
}

// Initialize wishlist when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.wishlist = new Wishlist();
}); 